import {
  RESET_ORDER_SUBMITTED,
} from 'constants/ActionTypes';

const resetOrderSubmittedReducer = () => ({ type: RESET_ORDER_SUBMITTED });

export default resetOrderSubmittedReducer;
